import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { api } from "@/lib/api";
import { useApp } from "@/context/AppContext";
import { Btn } from "@/components/sales/ui";
import { OUTCOMES, STAGES } from "@/components/sales/constants";

export const OutcomeDialog = ({ company, open, onClose }) => {
  const { run } = useApp();
  const [f, setF] = useState({ outcome: "", contact_id: "", note: "", callback_at: "", renewal_date: "", stage: "" });
  const set = (k) => (v) => setF((s) => ({ ...s, [k]: v?.target ? v.target.value : v }));
  const save = async () => {
    const body = { outcome: f.outcome, note: f.note, contact_id: f.contact_id || null, stage: f.stage || null, renewal_date: f.renewal_date || null,
      callback_at: f.callback_at ? new Date(f.callback_at).toISOString() : null };
    if (await run(() => api.post(`/sales/companies/${company.id}/outcome`, body), "Outcome saved")) {
      setF({ outcome: "", contact_id: "", note: "", callback_at: "", renewal_date: "", stage: "" });
      onClose();
    }
  };
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-h-[92vh] overflow-y-auto sm:max-w-2xl" aria-describedby={undefined} data-testid="outcome-dialog">
        <DialogHeader><DialogTitle className="font-display text-2xl">How did the call go?</DialogTitle></DialogHeader>
        <div className="grid grid-cols-2 gap-2 sm:grid-cols-5">
          {OUTCOMES.map((o) => (
            <button key={o.key} onClick={() => set("outcome")(o.key)} data-testid={`outcome-${o.key}`}
              className="rounded-xl border p-3 text-sm font-semibold transition-colors hover:bg-white/5"
              style={f.outcome === o.key ? { borderColor: o.color, background: `${o.color}22`, color: o.color } : {}}>{o.label}</button>
          ))}
        </div>
        {f.outcome && (
          <div className="fade-up space-y-3">
            <div className="flex flex-wrap gap-2">
              <span className="self-center text-xs font-semibold uppercase tracking-wider text-muted-foreground">Spoke to</span>
              {[{ id: "", name: "Not sure / nobody" }, ...(company.contacts || [])].map((c) => (
                <button key={c.id} onClick={() => set("contact_id")(c.id)} data-testid={`outcome-contact-${c.id || "none"}`}
                  className={`rounded-full border px-3 py-1 text-sm ${f.contact_id === c.id ? "border-cyan-400 bg-cyan-400/10 text-cyan-200" : "text-muted-foreground"}`}>{c.name}</button>
              ))}
            </div>
            <Textarea value={f.note} onChange={set("note")} rows={2} placeholder="Short note (optional)" data-testid="outcome-note-input" />
            <div className="grid gap-3 sm:grid-cols-3">
              <label className="space-y-1 text-xs text-muted-foreground">Call back on (creates a reminder)<Input type="datetime-local" value={f.callback_at} onChange={set("callback_at")} data-testid="outcome-callback-input" /></label>
              <label className="space-y-1 text-xs text-muted-foreground">Contract renewal date<Input type="date" value={f.renewal_date} onChange={set("renewal_date")} data-testid="outcome-renewal-input" /></label>
              <label className="space-y-1 text-xs text-muted-foreground">Move stage to
                <select value={f.stage} onChange={set("stage")} className="h-10 w-full rounded-md border bg-card px-2 text-sm text-foreground" data-testid="outcome-stage-select">
                  <option value="">Automatic</option>{STAGES.map((s) => <option key={s.key} value={s.key}>{s.label}</option>)}
                </select></label>
            </div>
            {f.outcome === "do_not_contact" && <p className="text-xs text-red-300">This company will be marked Do Not Contact and removed from Find Next Lead.</p>}
            <div className="flex justify-end"><Btn variant="primary" onClick={save} data-testid="outcome-save-btn">Save outcome</Btn></div>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};
